import './upload.less';
import PropTypes from 'prop-types';
import React from 'react';

const Upload = props => {
	return (
		<div className="form-element-upload--wrap">
			<div className="form-element-upload">
				{ !props.input.value ? UploadRender(props) : PreviewRender(props) }
			</div>

			{!props.input.value && props.meta.touched && props.meta.error && (
				<div className="form-element-error"><span>{ props.meta.error }</span></div>
			)}
		</div>
	);
};

const UploadRender = props => (
	<div className="form-element-upload__control">
		<label className="label">{props.placeholder}</label>
		{ !props.disabled && (
			<input
				type="file"
				className="control"
				onChange={e => props.preparationFile(e.target.files[0], props.input.onChange)}/>
		) }
	</div>
);

const PreviewRender = props => (
	<div className="form-element-upload__preview">
		<div className="form-element-upload__preview-img">
			<img src={props.input.value} alt=""/>
		</div>
		<div className="form-element-upload__preview-control">
			<label className="label">{props.placeholder}</label>
			{ !props.disabled && (
				<input
					type="file"
					className="control"
					onChange={e => props.preparationFile(e.target.files[0], props.input.onChange)}/>
			)}
		</div>
	</div>
);

Upload.propTypes = {
	input: PropTypes.object,
	meta: PropTypes.object
};

UploadRender.propTypes = {
	placeholder: PropTypes.string,
	input: PropTypes.object,
	preparationFile: PropTypes.func,
	disabled: PropTypes.bool
};

PreviewRender.propTypes = {
	placeholder: PropTypes.string,
	input: PropTypes.object,
	preparationFile: PropTypes.func,
	disabled: PropTypes.bool
};

export default Upload;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/upload.js